import React, { useEffect, useState } from "react";

import {
  Box,
  Typography,
  CircularProgress,
  Paper,
  Tabs,
  Tab,
  IconButton,
   Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  Button,
  TextField,
  InputLabel,
  MenuItem,
  Select
} from "@mui/material";
import TabPanel from "../../component/TabPanel";

import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-material.css";
import { AgGridReact } from "ag-grid-react";
import {
  employeeProjectsTable,
  employeeTimesheetTable,
  projectActivitiesTable,
  projectEmployeesTable,
  projectReccuringActivitiesTable,
  projectTaskTable,
  projectTimesheetTable,
  purchaseTableForProject,
} from "../../config/grid-columns-defs";

import { useDispatch, useSelector } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import {
  deleteProject,
  getLowestLevelTask,
  getProjectById,
  getProjectList,
  getProjectTasks,
  // updateProject,
} from "../../api/project";
import { handleAxiosError } from "../../config/action-config";

import {
  createTask,
  deleteTask,
  updateTask,
  updateTaskBudget,
} from "../../api/task";
import {
  assignEmployeeToProject,
  deleteEmployeeProject,
  updateEmployeeProject,
} from "../../api/employeeProject";

import { showAlert, showSuccess } from "../../actions/alert";

import {
  
  allActivityAttachment,
  createActivity,
  deleteActivity,
  getActivities,
  getRecurringActivities,
  updateActivity,
 
} from "../../api/activity";
import AddActivityDialog from "./dialog.add-activity";

import { Delete } from "@mui/icons-material";
import { getVendorList } from "../../api/vendor";
import CollapsibleTable from "../../component/CollapsibleTable";



import BasicColumnChart from "../../component/BasicColumnChart";
import RadialProgressChart from "../../component/RadialProgressChart";

import DeleteDialog from "./dialog.delete";
import AddTaskDialog from "./dialog.add-task";
import UpdateBudgetDialog from "./dialog.update-budget";
import UpdateTaskDialog from "./dialog.update-task";
import AddEmployeeDialog from "./dialog.add-employee";

import UpdateActivityDialog from "./dialog.update-activity";
import ChatDrawer from "./chat-drawer";
import { AttachFile, Forum, InsertDriveFile } from "@mui/icons-material";
import ConditionalRenderer from "../../component/ConditionalRenderer";
import AgGridTable from "../../component/AgGridTable";
import { getPurchases } from "../../api/purchase";
import { getTimesheetByProjectId } from "../../api/timesheet";
import UpdateEmployeeDialog from "./dialog.update-employee";
import { getEmployees } from "../../api/employee";
import { formatCurrency } from "../../config/grid-value-formatters";
import AgGridPaginatedTable from "../../component/AgGridPaginatedTable";
import AddRecurringActivityDialog from "./dialog.add-recurring-activity";
import UpdateRecurringActivityDialog from "./dialog.update-recurring-activity";
import ItemDialogUploadDoc from "../../component/DialogUploadExcel";
import { useMediaQuery } from "@material-ui/core";
import ColumnBarChart from "../../component/ColumnBarChart";
import CustomizedBarChartTable from "../../component/CustomizedTeamWorkloadBarChartTable";
import ProjectActivitiesAddActivityDialog from "./dialog.project.activities.add-activity";
import ProjectActivitiesUpdateActivityDialog from "./dialog.project.activities.update-activity";
import ProjectTaskAddActivityDialog from "./dialog.project-task-add-activity";
import ProjectTaskAddEmployeeDialog from "./dialog.project-task-add-employee";
import ViewProjectRecurringActivities from "./view-project-recurring-activities";
import ProjectAttachments from "./project.attachments";
import ProjectDashboard from "./project-dashboard";
import {insertNewpurchaseOrder} from "../../api/purchase";
const deleteApis = {
  PROJECT: deleteProject,
  TASK: deleteTask,
  EMPLOYEE: deleteEmployeeProject,
  ACTIVITY: deleteActivity,
};

const emptyProjectData = {
  project_name: "",
  project_type: "",
  project_description: "",
  budget: "",
  id: "",
  pm_id: "",
  start_date: "",
  end_date: "",
  status: "",
  creation_date: "",
  customer_id: "",
  customer_name: "",
  customer_email: "",
};
const expenseTypes = ["Labor", "Material", "Equipment"];

const initialExpense = {
 vendor_id : "", 
    project_id : "", 
    total_amount : "", 
    shipping_date : "",
    discount_terms :"" , 
    fob_instruction : "", 
};


export default function ViewProject() {
  // useEffect(() => {
  //   const projectType = localStorage.getItem("projectType");

  // }, []);
  const user = useSelector((state) => state.user);
  const params = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(true);
  const [taskCodeBool, setTaskCodeBool] = useState(false);
  const [projectData, setProjectData] = useState(emptyProjectData);
  const [allTasks, setAllTasks] = useState([]);
  const [lowestTasks, setLowestTasks] = useState([]);
  const [tasks, setTasks] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [activities, setActivities] = useState([]);
  const [recurringActivities, setRecurringActivities] = useState([]);
  const [employeeTaskName, setEmployeeTaskName] = useState("");
  const [employeeTabEmployeeName, setEmployeeTabEmployeeName] = useState("");
  const [activityTaskName, setActivityTaskName] = useState("");
  const [activityEmployeeName, setActivityEmployeeName] = useState("");
  const [recurringActivityTaskName, setRecurringActivityTaskName] =
    useState("");
  const [recurringActivityEmployeeName, setRecurringActivityEmployeeName] =
    useState("");
  const [timesheetTaskName, setTimesheetTaskName] = useState("");
  const [timesheetEmployeeName, setTimesheetEmployeeName] = useState("");
  const [employeeTableRefreshCount, setEmployeeTableRefreshCount] = useState(0);
  function refreshEmployeeTableTable() {
    setEmployeeTableRefreshCount((prev) => prev + 1);
  }
  const [activitiesRefreshCount, setActivitiesRefreshCount] = useState(0);
  function refreshactivitiesTable() {
    setActivitiesRefreshCount((prev) => prev + 1);
  }
  const [recurringActivitiesRefreshCount, setRecurringActivitiesRefreshCount] =
    useState(0);
  function refreshRecurringactivitiesTable() {
    setRecurringActivitiesRefreshCount((prev) => prev + 1);
  }
  const [timesheetRefreshCount, setTimesheetRefreshCount] = useState(0);
  function refreshTimesheetTable() {
    setTimesheetRefreshCount((prev) => prev + 1);
  }
  const [openDialog, setOpenDialog] = useState({
    ADD_TASK: false,
    UPDATE_TASK: false,
    ADD_EMPLOYEE: false,
    PROJECT_TASK_ADD_EMPLOYEE: false,
    UPDATE_BUDGET: false,
    DELETE: false,
    ADD_ACTIVITY: false,
    PROJECT_ACTIVITY_ADD_ACTIVITY: false,
    PROJECT_ACTIVITY_UPDATE_ACTIVITY: false,
    ADD_RECURRING_ACTIVITY: false,
    UPDATE_RECURRING_ACTIVITY: false,
    UPDATE_EMPLOYEE: false,
    UPLOAD_EXCEL: false,
    PROJECT_TASK_ADD_ACTIVITY: false,
  });

  const [openChatDrawer, setOpenChatDrawer] = useState(false);
  const [selectedActivityRow, setSelectedActivityRow] = useState(0);
  const [selectedChild, setSelectedChild] = useState({});
  const [selectedRecurringActivityRow, setSelectedRecurringActivityRow] =
    useState(0);

  const [employeeTable, setProjectEmployee] = useState(projectEmployeesTable);
  const [tasksTable, setProjectTasks] = useState(projectTaskTable);
  const [activityType, setActivityType] = useState("");
  const [refreshRecurringData, setRefreshRecurringData] = useState(false);
  const [refreshColumnBarChartData, setRefreshColumnBarChartData] =
    useState(false);
  const [refreshCustBarChartData, setRefreshCustBarChartData] = useState(false);

  // PO
  
  // PO

  useEffect(() => {
    let obj = projectEmployeesTable.find((o) => o.headerName === "Bill Rate");

    if (
      (user.role === "Admin" || projectData.pm_id === user.roleId) &&
      localStorage.getItem("projectType") === "Time & Material"
    ) {
      addAdditionalColumn(obj, setProjectEmployee);
    } else {
      const newArray = projectEmployeesTable.filter(
        (item) => item.headerName !== "Bill Rate"
      );
      setProjectEmployee(newArray);
    }
  }, [projectEmployeesTable]);
  useEffect(() => {
    let obj = projectTaskTable.find((o) => o.headerName === "Actual");

    if (
      (user.role === "Admin" || projectData.pm_id === user.roleId) &&
      localStorage.getItem("projectType") === "Time & Material"
    ) {
      addAdditionalColumnProjectTaskTable(obj);
    } else {
      addAdditionalColumnProjectTaskTable(obj);
      const newArrayTask = projectTaskTable.filter(
        (item) => item.headerName !== "Actual"
      );

      setProjectTasks(newArrayTask);
    }
  }, [projectTaskTable]);
  const { isClicked } = useSelector((state) => state.tab);
  useEffect(() => {
    if (isClicked === true) {
      setTabIndex(2);
    } else {
    }
  }, [isClicked]);
  if (!projectActivitiesTable.some((d) => d.headerName === "Comments")) {
    projectActivitiesTable.unshift(
      {
        headerName: "Comments",
        wrapText: true,
        autoHeight: true,
        cellStyle: { fontSize: "11px" },
        minWidth: 100,
        headerClass: "justify-center",
        cellClass: "pmt-ag-cell-font justify-center",
        cellRenderer: (params) => (
          <IconButton
            title="Comments"
            color="primary"
            // onClick={() => {
            //   setSelectedActivityRow(params.data.id);
            //   setOpenChatDrawer(true);
            // }}
          >
            <Forum />
          </IconButton>
        ),
      },
      {
        headerName: "Documents",
        wrapText: true,
        autoHeight: true,
        cellStyle: { fontSize: "11px" },
        minWidth: 100,
        headerClass: "justify-center",
        cellClass: "pmt-ag-cell-font justify-center",
        cellRenderer: (params) => (
          <IconButton
            title="Documents"
            color="primary"
            onClick={() => {
              let allowedToSelect =
                /admin/i.test(user.role) ||
                projectData.pm_id === user.roleId ||
                (/user|ReportingManager/i.test(user.role) &&
                  params.data.employee_id === user.roleId);
              if (allowedToSelect) {
                dispatch({ type: "CLICKED" });
                navigate(`activities-documents/${params.data.id}`);
              }
              return;
            }}
          >
            <InsertDriveFile />
          </IconButton>
        ),
      }
    );
  }
  if (
    !projectReccuringActivitiesTable.some((d) => d.headerName === "Comments")
  ) {
    projectReccuringActivitiesTable.unshift({
      headerName: "Comments",
      wrapText: true,
      autoHeight: true,
      cellStyle: { fontSize: "11px" },
      minWidth: 100,
      headerClass: "justify-center",
      cellClass: "pmt-ag-cell-font justify-center",
      cellRenderer: (params) => (
        <IconButton
          color="primary"
          // onClick={() => {
          //   setSelectedActivityRow(params.data.id);
          //   setOpenChatDrawer(true);
          // }}
        >
          <Forum />
        </IconButton>
      ),
    });
  }
  function toggleDialogOpen(dialog) {
    setOpenDialog((prev) => ({ ...prev, [dialog]: !openDialog[dialog] }));
  }

  useEffect(() => {
    if (params.id) {
      loadMasterData(10, 0);
      loadMasterDataForEmployeesList();
    }
    return;
  }, [params.id]);

  useEffect(() => {
    if (projectData.id) {
      loadProjectTaskData();
      loadLowestLevelTask();
      loadProjectActivities(10, 0);
    }
  }, [projectData.id]);

  async function loadMasterData(limit, offset) {
    try {
      const { data } = await getProjectById(
        params.id,
        {
          task_name: employeeTaskName,
          employee_name: employeeTabEmployeeName,
          limit,
          offset,
        },
        user.token
      );
      setProjectData(data.data.project);
      // setEmployees(data.data.employees);
      return {
        rows: data.data.employees,
        total: data.data.total,
        error: false,
      };
    } catch (error) {
      handleAxiosError(error, dispatch);
      return { error: true };
    } finally {
      setLoading(false);
    }
  }
  async function loadMasterDataForEmployeesList(limit, offset) {
    try {
      const { data } = await getProjectById(
        params.id,
        {
          task_name: "",
          employee_name: "",
        },
        user.token
      );

      setEmployees(data.data.employees);
    } catch (error) {
      handleAxiosError(error, dispatch);
    }
  }

  async function loadProjectTaskData() {
    try {
      const { data } = await getProjectTasks(projectData.id, user.token);
      setAllTasks(data.data);
      const parsedData = createTree(data.data, null);
      setTasks(parsedData || []);
    } catch (error) {
      handleAxiosError(error);
    }
  }

  async function loadLowestLevelTask() {
    let specific = false;
    if (user.role === "User") {
      specific = true;
    }
    try {
      const { data } = await getLowestLevelTask(
        projectData.id,
        user.token,
        specific
      );
      setLowestTasks(data.data);
    } catch (error) {
      handleAxiosError(error);
    }
  }

  async function loadProjectActivities(limit, offset) {
    try {
      const { data } = await getActivities(
        projectData.id,
        {
          is_recurring: false,
          task_name: activityTaskName,
          employee_name: activityEmployeeName,
          limit,
          offset,
        },
        user.token
      );
      setActivities(data.data);
      return {
        rows: data.data,
        total: data.total,
        error: false,
      };
    } catch (error) {
      handleAxiosError(error, dispatch);
      return { error: true };
    } finally {
      setLoading(false);
    }
  }
  async function loadProjectReccuringActivities(limit, offset) {
    try {
      const { data } = await getRecurringActivities(
        projectData.id,
        {
          is_recurring: true,
          task_name: recurringActivityTaskName,
          employee_name: recurringActivityEmployeeName,
          limit,
          offset,
        },
        user.token
      );
      setRecurringActivities(data.data);
      return {
        rows: data.data,
        total: data.total,
        error: false,
      };
    } catch (error) {
      handleAxiosError(error, dispatch);
      return { error: true };
    } finally {
      setLoading(false);
    }
  }

  const [tabIndex, setTabIndex] = useState(user.role === "User" ? 1 : 0);

  const [selectedTaskRow, setSelectedTaskRow] = useState(0);
  const [selectedEmployeeRow, setSelectedEmployeeRow] = useState(0);

  const [deletingContent, setDeletingContent] = useState({ table: "", row: 0 });

  async function onDelete() {
    const deleteApi = deleteApis[deletingContent.table];
    try {
      const { data } = await deleteApi(deletingContent.row, user.token);

      dispatch(showAlert(data.msg));
      setDeletingContent({ type: "", row: 0 });
      setSelectedRecurringActivityRow(0);
      setSelectedActivityRow(0);
      setSelectedEmployeeRow(0);
      setSelectedTaskRow(0);
      loadLowestLevelTask();
      loadMasterDataForEmployeesList();
      refreshEmployeeTableTable();
      switch (deletingContent.table) {
        case "PROJECT":
          navigate("/projects");
          break;
        case "EMPLOYEE":
          refreshEmployeeTableTable();
          refreshactivitiesTable();
          refreshRecurringactivitiesTable();
          setRefreshRecurringData(!refreshRecurringData);
          break;
        case "TASK":
          loadProjectTaskData();
          refreshactivitiesTable();
          refreshRecurringactivitiesTable();
          setRefreshRecurringData(!refreshRecurringData);
          break;
        case "ACTIVITY":
          refreshactivitiesTable();
          refreshRecurringactivitiesTable();

          break;
        default:
          break;
      }
    } catch (error) {
      setDeletingContent({ table: "", row: 0 });
      handleAxiosError(error);
    }
  }

  async function handleEmployeeAdd(postData) {
    let projectType = localStorage.getItem("projectType");
    if (projectType === "FIXED" || projectType === "SUBSCRIPTION") {
      delete postData.bill_rate;
    }
    try {
      const { data } = await assignEmployeeToProject(
        { ...postData, project_id: projectData.id },
        user.token
      );
      loadMasterDataForEmployeesList();
      refreshEmployeeTableTable();
      dispatch(showAlert(data.msg));
      toggleDialogOpen("ADD_EMPLOYEE");
      setSelectedEmployeeRow(0);
    } catch (error) {
      handleAxiosError(error);
    }
  }
  async function handleProjectTaskEmployeeAdd(postData) {
    let projectType = localStorage.getItem("projectType");
    if (projectType === "FIXED" || projectType === "SUBSCRIPTION") {
      delete postData.bill_rate;
    }
    try {
      const { data } = await assignEmployeeToProject(
        { ...postData, project_id: projectData.id },
        user.token
      );
      loadMasterDataForEmployeesList();
      refreshEmployeeTableTable();
      dispatch(showAlert(data.msg));
      toggleDialogOpen("PROJECT_TASK_ADD_EMPLOYEE");
    } catch (error) {
      handleAxiosError(error);
    }
  }
  async function onEmployeeUpdate(postData) {
    let projectType = localStorage.getItem("projectType");
    if (projectType === "FIXED" || projectType === "SUBSCRIPTION") {
      delete postData.bill_rate;
    }
    const newData = {
      ...postData,
      project_id: params.id,
      ep_id: selectedEmployeeRow,
    };

    try {
      const { data } = await updateEmployeeProject(newData, user.token);
      refreshEmployeeTableTable();
      toggleDialogOpen("UPDATE_EMPLOYEE");
      dispatch(showAlert(data.msg));
      setSelectedEmployeeRow(0);
    } catch (error) {
      handleAxiosError(error);
    }
  }

  async function handleTaskAdd(postData) {
    try {
      const { data } = await createTask(
        { ...postData, project_id: projectData.id },
        user.token
      );
      dispatch(showAlert(data.msg));
      loadMasterDataForEmployeesList();
      loadProjectTaskData();
      loadLowestLevelTask();
      toggleDialogOpen("ADD_TASK");
    } catch (error) {
      handleAxiosError(error);
    }
  }

  const [updatingTaskRow, setUpdatingTaskRow] = useState({});
  async function handleTaskUpdate(patchData) {
    try {
      const { data } = await updateTask(selectedTaskRow, patchData, user.token);
      dispatch(showAlert(data.msg));
      loadProjectTaskData();
      refreshactivitiesTable();
      refreshRecurringactivitiesTable();
      setRefreshRecurringData(!refreshRecurringData);
      refreshEmployeeTableTable();
      loadLowestLevelTask();
      toggleDialogOpen("UPDATE_TASK");
    } catch (error) {
      handleAxiosError(error);
    }
  }

  async function handleBudgetUpdate(patchData) {
    try {
      const { data } = await updateTaskBudget(
        { project_id: projectData.id, task_budgets: patchData },
        user.token
      );
      toggleDialogOpen("UPDATE_BUDGET");
      loadProjectTaskData();
      loadLowestLevelTask();
      dispatch(showAlert(data.msg));
    } catch (error) {
      handleAxiosError(error, dispatch);
    }
  }

  async function onActivityAdd(postData) {
    const combinedData = { ...postData, is_recurring: false };
    try {
      const { data } = await createActivity(
        { ...combinedData, project_id: projectData.id },
        user.token
      );
      setRefreshColumnBarChartData(!refreshColumnBarChartData);
      setRefreshCustBarChartData(!refreshCustBarChartData);
      loadProjectTaskData();
      loadMasterDataForEmployeesList();
      loadLowestLevelTask();
      refreshactivitiesTable();
      toggleDialogOpen("ADD_ACTIVITY");
      dispatch(showAlert(data.msg));
    } catch (error) {
      handleAxiosError(error);
    }
  }
  async function onProjectTaskActivityAdd(postData) {
    const combinedData = { ...postData, is_recurring: false };
    try {
      const { data } = await createActivity(
        { ...combinedData, project_id: projectData.id },
        user.token
      );
      setRefreshColumnBarChartData(!refreshColumnBarChartData);
      setRefreshCustBarChartData(!refreshCustBarChartData);
      loadProjectTaskData();
      loadMasterDataForEmployeesList();
      refreshactivitiesTable();
      toggleDialogOpen("PROJECT_TASK_ADD_ACTIVITY");
      dispatch(showAlert(data.msg));
    } catch (error) {
      handleAxiosError(error);
    }
  }

  async function onActivityUpdate(patchData) {
    try {
      const { data } = await updateActivity(
        selectedActivityRow,
        patchData,
        user.token
      );
      setRefreshColumnBarChartData(!refreshColumnBarChartData);
      setRefreshCustBarChartData(!refreshCustBarChartData);
      loadProjectTaskData();
      refreshactivitiesTable();
      toggleDialogOpen("UPDATE_ACTIVITY");
      dispatch(showAlert(data.msg));
      setSelectedActivityRow(0);
    } catch (error) {
      handleAxiosError(error);
    }
  }
  async function onRecurringActivityAdd(postData) {
    const combinedData = { ...postData, is_recurring: true };
    try {
      const { data } = await createActivity(
        { ...combinedData, project_id: projectData.id },
        user.token
      );
      loadMasterDataForEmployeesList();
      refreshRecurringactivitiesTable();
      toggleDialogOpen("ADD_RECURRING_ACTIVITY");

      dispatch(showAlert(data.msg));
    } catch (error) {
      handleAxiosError(error);
    }
  }

  async function onRecurringActivityUpdate(patchData) {
    try {
      const { data } = await updateActivity(
        selectedRecurringActivityRow,
        patchData,
        user.token
      );
      refreshRecurringactivitiesTable();
      toggleDialogOpen("UPDATE_RECURRING_ACTIVITY");
      dispatch(showAlert(data.msg));
      setSelectedRecurringActivityRow(0);
    } catch (error) {
      handleAxiosError(error);
    }
  }

  async function getPurchaseData(limit, offset) {
    try {
      const { data } = await getPurchases(
        { project: projectData.id },
        user.token
      );
      return { rows: data.data, error: false };
    } catch (error) {
      handleAxiosError(error, dispatch);
      return { error: true };
    } finally {
      // setLoading(false);
    }
  }

  async function getTimesheetData(limit, offset) {
    try {
      const { data } = await getTimesheetByProjectId(
        projectData.id,
        {
          task_name: timesheetTaskName,
          employee_name: timesheetEmployeeName,
          limit,
          offset,
        },
        user.token
      );
      return { rows: data.data, total: data.total, error: false };
    } catch (error) {
      handleAxiosError(error, dispatch);
      return { error: true };
    } finally {
      // setLoading(false);
    }
  }
  const onItemDialogAttachmentSubmit = async (formData) => {
    try {
      const { data } = await allActivityAttachment(formData, user.token);

      // getTicketAttachmentTableData();
      dispatch(showAlert(data.msg));
      toggleDialogOpen("UPLOAD_EXCEL");
    } catch (error) {
      toggleDialogOpen("UPLOAD_EXCEL");
      handleAxiosError(error, dispatch);
    }
  };

  useEffect(() => {
    refreshEmployeeTableTable();
  }, [employeeTaskName, employeeTabEmployeeName]);
  useEffect(() => {
    refreshactivitiesTable();
  }, [activityTaskName, activityEmployeeName]);
  useEffect(() => {
    refreshRecurringactivitiesTable();
  }, [recurringActivityEmployeeName, recurringActivityTaskName]);
  useEffect(() => {
    refreshTimesheetTable();
  }, [timesheetTaskName, timesheetEmployeeName]);

  return loading ? (
    <Loading />
  ) : (
    <Box sx={{ flexGrow: 1, px: 5, py: 2 }} style={{ padding: "0px" }}>
 <Box
  sx={{
    width: "100%",
    backgroundColor: "#ffffff",
    borderBottom: "1px solid #e0e0e0",
    boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
  }}
  className="project-tabs"
>
  <Tabs
    value={tabIndex}
    onChange={(e, nv) => setTabIndex(nv)}
    variant="scrollable"
    scrollButtons="auto"
    allowScrollButtonsMobile
    aria-label="Project Tabs"
    textColor="primary"
    indicatorColor="primary"
    sx={{
      // px: 2,
      ".MuiTabs-indicator": {
        height: 3,
        // borderRadius: 2,
        backgroundColor: "#becfff",
      },
      ".MuiTab-root": {
        textTransform: "none",
        fontSize: 15,
        fontWeight: 500,
        minHeight: 48,
        // px: 3,
        py: 1.2,
        color: "#444",
        // borderRadius: "0px 0px 0 0",
        transition: "all 0.2s",
        "&.Mui-selected": {
          color: "#08459c",
          backgroundColor: "#becfff",
          fontWeight: 600,
        },
        "&:hover": {
          backgroundColor: "#f5f5f5",
        },
        "&.Mui-disabled": {
          color: "#bbb",
          opacity: 0.6,
        },
      },
    }}
  >
    <Tab
      label={`Project Tasks ${tabIndex === 0 ? `⤵` : ""}`}
      disabled={
        user.role === "Trial_User"
          ? false
          : /user/i.test(user.role) && user.roleId !== projectData.pm_id
      }
    />
    <Tab label={`Resources   ${tabIndex === 1 ? `⤵` : ""}`} />
    <Tab label={`Activities     ${tabIndex === 2 ? `⤵` : ""}`} />
    {/* <Tab label={`Recurring Activities   ${tabIndex === 3 ? `⤵` : ""}`}  /> */}
    
    <Tab
      label={`Timesheet   ${tabIndex === 3? `⤵` : ""}`}
      disabled={
        user.role === "Trial_User"
          ? false
          : /user|reportingmanager/i.test(user.role) && user.roleId !== projectData.pm_id
      }
    />
    <Tab
      label={`Dashboard   ${tabIndex === 4 ? `⤵` : ""}`}
      disabled={
        user.role === "Trial_User"
          ? false
          : /user|reportingmanager/i.test(user.role) && user.roleId !== projectData.pm_id
      }
    />
    <Tab
      label={`Documents    ${tabIndex === 5 ? `⤵` : ""}`}
      disabled={
        user.role === "Trial_User"
          ? false
          : /user|reportingmanager/i.test(user.role) && user.roleId !== projectData.pm_id
      }
    />
    <Tab
      label={`Purchase Orders  ${tabIndex === 6 ? `⤵` : ""}`} 
      disabled={
        user.role === "Trial_User"
          ? false
          : /user|reportingmanager/i.test(user.role) && user.roleId !== projectData.pm_id
      }
    />
  </Tabs>
</Box>


      <TabPanel value={tabIndex} index={0}>
        <Paper>
          <Box sx={{ display: "flex", columnGap: 1, p: 2, borderBottom: 1 }}>
            <ConditionalRenderer
              conditions={[
                user.role === "Admin",
                projectData.pm_id === user.roleId,
              ]}
              match="SOME"
            >
              <Button
                variant="contained"
                onClick={() => {
                  toggleDialogOpen("ADD_TASK");
                }}
                className="blue-button"
              >
                Add Task
              </Button>

              <ConditionalRenderer conditions={[Boolean(selectedTaskRow)]}>
                <>
                  <Button
                    variant="contained"
                    onClick={() => {
                      setDeletingContent({
                        table: "TASK",
                        row: selectedTaskRow,
                      });
                    }}
                    className="blue-button"
                  >
                    Delete Task
                  </Button>
                  <Button
                    variant="contained"
                    onClick={() => {
                      setUpdatingTaskRow(selectedTaskRow);
                      toggleDialogOpen("UPDATE_TASK");
                    }}
                    className="blue-button"
                  >
                    Update Task
                  </Button>
                  {selectedChild.children !== null ? (
                    <></>
                  ) : (
                    <>
                      <Button
                        variant="contained"
                        onClick={() => {
                          setTaskCodeBool(true);
                          // setUpdatingTaskRow(selectedTaskRow);
                          toggleDialogOpen("PROJECT_TASK_ADD_ACTIVITY");
                        }}
                        className="blue-button"
                      >
                        Add Activity
                      </Button>
                      <Button
                        variant="contained"
                        onClick={() => {
                          setTaskCodeBool(true);
                          // setUpdatingTaskRow(selectedTaskRow);
                          toggleDialogOpen("ADD_EMPLOYEE");
                        }}
                        className="blue-button"
                      >
                        Add Resource
                      </Button>
                    </>
                  )}
                </>
              </ConditionalRenderer>

              <Button
                variant="contained"
                style={{ padding: "5px 7px", marginLeft: "auto" }}
                onClick={() => {
                  toggleDialogOpen("UPDATE_BUDGET");
                }}
                className="blue-button"
              >
                Update Budget
              </Button>
            </ConditionalRenderer>
          </Box>
          <CollapsibleTable
            rows={tasks}
            headers={tasksTable}
            selected={selectedTaskRow}
            setSelected={setSelectedTaskRow}
            setSelectedData={setSelectedChild}
          />
        </Paper>
      </TabPanel>

      <TabPanel value={tabIndex} index={1}>
        <Paper>
          <ConditionalRenderer
            conditions={[
              user.role === "Admin",
              projectData.pm_id === user.roleId,
            ]}
            match="SOME"
          >
            <Box
              sx={{
                display: { sm: "flex", xs: "grid" },
                columnGap: 1,
                p: 2,
                borderBottom: 1,
              }}
            >
              <Button
                variant="contained"
                onClick={() => {
                  toggleDialogOpen("PROJECT_TASK_ADD_EMPLOYEE");
                }}
                className="blue-button"
                sx={{ marginBottom: { sm: "0px", xs: "5px" } }}
              >
                Add Resource
              </Button>

              <ConditionalRenderer conditions={[Boolean(selectedEmployeeRow)]}>
                <Button
                  variant="contained"
                  onClick={() => {
                    setDeletingContent({
                      table: "EMPLOYEE",
                      row: selectedEmployeeRow,
                    });
                  }}
                  className="blue-button"
                  sx={{ marginBottom: { sm: "0px", xs: "5px" } }}
                >
                  Delete Selected
                </Button>
              </ConditionalRenderer>
              <ConditionalRenderer conditions={[Boolean(selectedEmployeeRow)]}>
                <Button
                  variant="contained"
                  onClick={() => {
                    toggleDialogOpen("UPDATE_EMPLOYEE");
                  }}
                  className="blue-button"
                  sx={{ marginBottom: { sm: "0px", xs: "5px" } }}
                >
                  Update Selected
                </Button>
              </ConditionalRenderer>
              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                lg={6}
                xl={6}
                sx={{ display: { sm: "flex" }, alignItems: { sm: "center" } }}
              >
                <TextField
                  size="small"
                  sx={{
                    marginRight: 1,
                    marginBottom: { sm: "0px", xs: "5px" },
                  }}
                  value={employeeTaskName}
                  label="Task Name"
                  onChange={(e) => {
                    setEmployeeTaskName(e.target.value);
                  }}
                  fullWidth
                />
                <TextField
                  fullWidth
                  size="small"
                  value={employeeTabEmployeeName}
                  label="Resource Name"
                  onChange={(e) => {
                    setEmployeeTabEmployeeName(e.target.value);
                  }}
                  // rowsMax={1}
                />
              </Grid>
            </Box>
          </ConditionalRenderer>

          {/* <div className="ag-theme-material" style={{ height: "300px" }}>
            <AgGridReact
              columnDefs={employeeTable}
              rowData={employees}
              rowSelection="single"
              onRowClicked={(params) => {
                setSelectedEmployeeRow(params.data.id);
              }}
            />
          </div> */}
          <div className="pmt-main-table">
            <AgGridPaginatedTable
              getTableRows={loadMasterData}
              columns={employeeTable}
              perPage={10}
              refreshCounter={employeeTableRefreshCount}
              rowSelection="single"
              onRowClicked={(params) => {
                setSelectedEmployeeRow(params.data.ep_id);
              }}
            />
          </div>
        </Paper>
      </TabPanel>
      <TabPanel value={tabIndex} index={2}>
        <Paper>
          <Box
            sx={{
              //display: "flex",
              //display: { xs: "grid", sm: "flex" },
              display: { lg: "flex", md: "flex", sm: "block", xs: "grid" },
              alignItems: "center",
              justifyContent: "space-between",
              p: 2,
              borderBottom: 1,
            }}
          >
            <ConditionalRenderer
              conditions={[
                user.role === "Admin",
                user.role === "User",
                user.role === "Trial_User",
                projectData.pm_id === user.roleId,
              ]}
              match="SOME"
            >
              <Button
                variant="contained"
                onClick={() => {
                  toggleDialogOpen("ADD_ACTIVITY");
                }}
                className="blue-button"
                sx={{
                  marginBottom: { xs: "5px", md: "0px" },
                  marginRight: { sm: "5px", md: "10px" },
                }}
              >
                Add Activity
              </Button>

              <ConditionalRenderer conditions={[Boolean(selectedActivityRow)]}>
                <Button
                  variant="contained"
                  className="blue-button"
                  onClick={() => {
                    toggleDialogOpen("UPDATE_ACTIVITY");
                  }}
                  sx={{
                    marginBottom: { xs: "5px", md: "0px" },
                    marginRight: { sm: "5px", md: "10px" },
                  }}
                >
                  Update Selected
                </Button>
              </ConditionalRenderer>
            </ConditionalRenderer>
            <ConditionalRenderer
              conditions={[
                user.role === "Admin",
                projectData.pm_id === user.roleId,
              ]}
              match="SOME"
            >
              <ConditionalRenderer conditions={[Boolean(selectedActivityRow)]}>
                <Button
                  className="blue-button"
                  variant="contained"
                  sx={{
                    marginBottom: { xs: "5px", md: "0px" },
                    marginRight: { sm: "5px", md: "10px" },
                  }}
                  onClick={() => {
                    setDeletingContent({
                      table: "ACTIVITY",
                      row: selectedActivityRow,
                    });
                  }}
                >
                  Delete Selected
                </Button>
              </ConditionalRenderer>
            </ConditionalRenderer>

            <Grid
              item
              xs={12}
              sm={12}
              md={6}
              lg={6}
              xl={6}
              display={{ sm: "flex !important" }}
              sx={{
                float: { lg: "right" },
              }}
            >
              <TextField
                size="small"
                fullWidth
                sx={{
                  marginRight: { sm: "5px", md: "10px" },
                  marginBottom: { xs: "5px", md: "0px" },
                }}
                value={activityEmployeeName}
                label="Resource Name"
                onChange={(e) => {
                  setActivityEmployeeName(e.target.value);
                }}
                // rowsMax={1}
              />
              <TextField
                size="small"
                fullWidth
                sx={{
                  marginRight: { sm: "5px", md: "10px" },
                  marginBottom: { xs: "5px", md: "0px" },
                }}
                value={activityTaskName}
                label="Task Name"
                onChange={(e) => {
                  setActivityTaskName(e.target.value);
                }}
              />
              <Button
                variant="contained"
                style={{ padding: "5px 7px" }}
                sx={{
                  marginBottom: { xs: "5px", md: "0px" },
                }}
                fullWidth
                onClick={() => {
                  setActivityType("y");
                  toggleDialogOpen("UPLOAD_EXCEL");
                }}
                className="blue-button"
              >
                Upload
              </Button>
            </Grid>
          </Box>

          <ChatDrawer
            open={openChatDrawer}
            setOpen={setOpenChatDrawer}
            activityId={selectedActivityRow}
          />
          {/* <div className="ag-theme-material" style={{ height: "300px" }}>
            <AgGridReact
              columnDefs={projectActivitiesTable}
              rowData={activities}
              rowSelection="single"
              onRowClicked={(params) => {
                let allowedToSelect =
                  /admin/i.test(user.role) ||
                  projectData.pm_id === user.roleId ||
                  (/user|ReportingManager/i.test(user.role) &&
                    activities[params.rowIndex].employee_id === user.roleId);
                if (allowedToSelect) {
                  setSelectedActivityRow(params.data.id);
                }
              }}
              onCellFocused={({ rowIndex, column }) => {
                if (column.colId === "0") {
                  let allowedToComment =
                    /admin/i.test(user.role) ||
                    projectData.pm_id === user.roleId ||
                    (/user|ReportingManager/i.test(user.role) &&
                      activities[rowIndex].employee_id === user.roleId);
                  if (allowedToComment) {
                    setSelectedActivityRow(activities[rowIndex].id);
                    setOpenChatDrawer(true);
                  }
                }
              }}
            />
          </div> */}
          <div className="pmt-controll-table">
            <AgGridPaginatedTable
              getTableRows={loadProjectActivities}
              columns={projectActivitiesTable}
              perPage={10}
              refreshCounter={activitiesRefreshCount}
              rowSelection="single"
              onRowClicked={(params) => {
                let allowedToSelect =
                  /admin/i.test(user.role) ||
                  projectData.pm_id === user.roleId ||
                  (/user|ReportingManager/i.test(user.role) &&
                    params.data.employee_id === user.roleId);
                if (allowedToSelect) {
                  setSelectedActivityRow(params.data.id);
                } else {
                  setSelectedActivityRow(0);
                }
              }}
              onCellClicked={({ rowIndex, column, data }) => {
                if (column.colId === "0") {
                  let allowedToComment =
                    /admin/i.test(user.role) ||
                    projectData.pm_id === user.roleId ||
                    (/user|ReportingManager/i.test(user.role) &&
                      data.employee_id === user.roleId);
                  if (allowedToComment) {
                    setSelectedActivityRow(data.id);
                    setOpenChatDrawer(true);
                  }
                }
              }}
            />
          </div>
        </Paper>
      </TabPanel>
      {/* <TabPanel value={tabIndex} index={3}>
        <ViewProjectRecurringActivities
          projectSelectId={params.id}
          refresh={refreshRecurringData}
        ></ViewProjectRecurringActivities>
      </TabPanel> */}
      {/* <TabPanel value={tabIndex} index={3}>
        <Paper>
          <Box
            sx={{
              display: { lg: "block", md: "flex", sm: "block", xs: "grid" },
              alignItems: "center",
              // justifyContent: "space-between",
              p: 2,
              borderBottom: 1,
            }}
          >
            <ConditionalRenderer
              conditions={[
                user.role === "Admin",
                user.role === "User",
                projectData.pm_id === user.roleId,
              ]}
              match="SOME"
            >
              <Button
                variant="contained"
                onClick={() => {
                  toggleDialogOpen("ADD_RECURRING_ACTIVITY");
                }}
                className="blue-button"
                sx={{
                  marginBottom: { xs: "5px", md: "0px" },
                  marginRight: { sm: "5px", md: "10px" },
                }}
              >
                Add Activity
              </Button>
            </ConditionalRenderer>
            <ConditionalRenderer
              conditions={[Boolean(selectedRecurringActivityRow)]}
            >
              <Button
                variant="contained"
                className="blue-button"
                sx={{
                  marginBottom: { xs: "5px", md: "0px" },
                  marginRight: { sm: "5px", md: "10px" },
                }}
                onClick={() => {
                  toggleDialogOpen("UPDATE_RECURRING_ACTIVITY");
                }}
              >
                Update Selected
              </Button>
            </ConditionalRenderer>
            <ConditionalRenderer
              conditions={[
                user.role === "Admin",
                projectData.pm_id === user.roleId,
              ]}
              match="SOME"
            >
              <ConditionalRenderer
                conditions={[Boolean(selectedRecurringActivityRow)]}
              >
                <Button
                  className="blue-button"
                  variant="contained"
                  sx={{
                    marginBottom: { xs: "5px", md: "0px" },
                    marginRight: { sm: "5px", md: "10px" },
                  }}
                  onClick={() => {
                    setDeletingContent({
                      table: "ACTIVITY",
                      row: selectedRecurringActivityRow,
                    });
                  }}
                >
                  Delete Selected
                </Button>
              </ConditionalRenderer>
            </ConditionalRenderer>
            <Grid
              item
              xs={12}
              sm={12}
              md={6}
              lg={6}
              xl={6}
              display={{ sm: "flex !important" }}
              sx={{
                float: { lg: "right" },
              }}
            >
              <TextField
                size="small"
                fullWidth
                sx={{
                  marginRight: { sm: "5px", md: "10px" },
                  marginBottom: { xs: "5px", md: "0px" },
                }}
                value={recurringActivityEmployeeName}
                label="Employee Name"
                onChange={(e) => {
                  setRecurringActivityEmployeeName(e.target.value);
                }}
                // rowsMax={1}
              />
              <TextField
                size="small"
                fullWidth
                sx={{
                  marginRight: { sm: "5px", md: "10px" },
                  marginBottom: { xs: "5px", md: "0px" },
                }}
                value={recurringActivityTaskName}
                label="Task Name"
                onChange={(e) => {
                  setRecurringActivityTaskName(e.target.value);
                }}
              />
              <Button
                variant="contained"
                style={{ padding: "5px 7px" }}
                fullWidth
                onClick={() => {
                  setActivityType("n");
                  toggleDialogOpen("UPLOAD_EXCEL");
                }}
                sx={{
                  marginBottom: { xs: "5px", md: "0px" },
                }}
                className="blue-button"
              >
                Upload
              </Button>
            </Grid>
          </Box>

          <ChatDrawer
            open={openChatDrawer}
            setOpen={setOpenChatDrawer}
            activityId={selectedRecurringActivityRow}
          />
        
          <div className="pmt-controll-table">
            <AgGridPaginatedTable
              getTableRows={loadProjectReccuringActivities}
              columns={projectReccuringActivitiesTable}
              perPage={10}
              refreshCounter={recurringActivitiesRefreshCount}
              rowSelection="single"
              onRowClicked={(params) => {
                let allowedToSelect =
                  /admin/i.test(user.role) ||
                  projectData.pm_id === user.roleId ||
                  (/user|ReportingManager/i.test(user.role) &&
                    params.data.employee_id === user.roleId);
                if (allowedToSelect) {
                  setSelectedRecurringActivityRow(params.data.id);
                } else {
                  setSelectedRecurringActivityRow(0);
                }
              }}
              onCellClicked={({ rowIndex, column, data }) => {
                if (column.colId === "0") {
                  let allowedToComment =
                    /admin/i.test(user.role) ||
                    projectData.pm_id === user.roleId ||
                    (/user|ReportingManager/i.test(user.role) &&
                      data.employee_id === user.roleId);
                  if (allowedToComment) {
                    setSelectedRecurringActivityRow(data.id);
                    setOpenChatDrawer(true);
                  }
                }
              }}
            />
          </div>
        </Paper>
      </TabPanel> */}
    
      <TabPanel value={tabIndex} index={3}>
        {/* <Paper> */}
        <Box
          sx={{
            display: "flex",
            // columnGap: 1, p: 2, pl: 0,
            borderBottom: 1,
          }}
        >
          <Grid container spacing={1} padding={{ md: "15px 0px" }}>
            <Grid item xs={12} sm={6} md={3} lg={3} xl={3}>
              <TextField
                size="small"
                fullWidth
                //sx={{ marginRight: 1 }}
                sx={{ marginBottom: { xs: "5px", sm: "0px" } }}
                value={timesheetEmployeeName}
                label="Resource Email"
                onChange={(e) => {
                  setTimesheetEmployeeName(e.target.value);
                }}
                // rowsMax={1}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3} lg={3} xl={3}>
              <TextField
                fullWidth
                sx={{ marginBottom: { xs: "5px", sm: "0px" } }}
                size="small"
                value={timesheetTaskName}
                label="Task Name"
                onChange={(e) => {
                  setTimesheetTaskName(e.target.value);
                }}
              />
            </Grid>
          </Grid>
        </Box>
        {/*<div className="pmt-controll-table">*/}
        <div className="pmt-scrollable-table">
          <AgGridPaginatedTable
            getTableRows={getTimesheetData}
            columns={projectTimesheetTable}
            // columns={employeeTimesheetTable}
            perPage={10}
            refreshCounter={timesheetRefreshCount}
          />
        </div>
        {/* </div> */}
        {/* <AgGridTable
            refreshCounter={0}
            columns={projectTimesheetTable}
            getTableRows={getTimesheetData}
          /> */}
        {/* </Paper> */}
      </TabPanel>
     {tabIndex ===4  &&<TabPanel value={tabIndex} index={4}>
        {allTasks.length ? (
          <>
            <br />

            <Grid container spacing={1} rowSpacing={1} columnSpacing={2}>
              {/* <Grid item md={8} lg={8}>
                  <BasicColumnChart
                    title="Actual vs Budget"
                    data={getFromattedActualAndBudgetData(allTasks)}
                  />
                </Grid> */}
              
              <Grid item xs={12} md={12} lg={12}>
                <ProjectDashboard   getPorojectCompletionPercent={getPorojectCompletionPercent}  allTasks={allTasks}     />   </Grid>
            </Grid>
            {/* <br />
            <Paper sx={{ p: 1 }}>
              <BasicColumnChart
                yText="USD $"
                title="Actual vs Cost"
                data={getFromattedActualAndCostData(allTasks)}
              />
            </Paper> */}
          </>
        ) : (
          <></>
        )}
      </TabPanel>} 
      <TabPanel value={tabIndex} index={5}>
        <ProjectAttachments id={params.id} />
      </TabPanel>
        <TabPanel value={tabIndex} index={6}>
        <Paper>
           <Box p={2}>
            {/* <Button variant="contained" size="small" onClick={() => setOpen(true)}>Add Purchase</Button> */}
          </Box> 
          <div className="pmt-controll-table">
            <AgGridTable
              refreshCounter={0}
              columns={purchaseTableForProject}
              getTableRows={getPurchaseData}
            />
          </div>
        </Paper>
      </TabPanel>
      <ItemDialogUploadDoc
        activityType={activityType}
        open={openDialog.UPLOAD_EXCEL}
        setOpen={toggleDialogOpen}
        onSubmit={onItemDialogAttachmentSubmit}
      />
      <DeleteDialog
        deletingContent={deletingContent}
        setDeletingContent={setDeletingContent}
        onDelete={onDelete}
      />

      <UpdateEmployeeDialog
        open={openDialog.UPDATE_EMPLOYEE}
        setOpen={toggleDialogOpen}
        lowestTasks={lowestTasks}
        employees={employees}
        projectId={params.id}
        selectedEmployee={employees.find(
          (a) => a.ep_id === selectedEmployeeRow
        )}
        onUpdate={onEmployeeUpdate}
        projectType={localStorage.getItem("projectType")}
      />

      <AddTaskDialog
        open={openDialog.ADD_TASK}
        setOpen={toggleDialogOpen}
        onAdd={handleTaskAdd}
        allTasks={allTasks}
        projectData={projectData}
      />

      <UpdateTaskDialog
        open={openDialog.UPDATE_TASK}
        setOpen={toggleDialogOpen}
        onUpdate={handleTaskUpdate}
        selectedTaskId={updatingTaskRow}
        allTasks={allTasks}
        lowestTasks={lowestTasks}
        projectData={projectData}
      />

      <UpdateBudgetDialog
        lowestTasks={lowestTasks}
        open={openDialog.UPDATE_BUDGET}
        setOpen={toggleDialogOpen}
        onUpdate={handleBudgetUpdate}
      />

      <AddActivityDialog
        selectedChild={selectedChild}
        taskCodeBool={taskCodeBool}
        setTaskCodeBool={setTaskCodeBool}
        open={openDialog.ADD_ACTIVITY}
        setOpen={toggleDialogOpen}
        lowestTasks={lowestTasks}
        employees={employees}
        onAdd={onActivityAdd}
      />

      <UpdateActivityDialog
        open={openDialog.UPDATE_ACTIVITY}
        setOpen={toggleDialogOpen}
        lowestTasks={lowestTasks}
        employees={employees}
        projectData={projectData}
        selectedActivity={activities.find((a) => {
          return a.id === selectedActivityRow;
        })}
        onUpdate={onActivityUpdate}
      />

      <AddRecurringActivityDialog
        open={openDialog.ADD_RECURRING_ACTIVITY}
        setOpen={toggleDialogOpen}
        lowestTasks={lowestTasks}
        employees={employees}
        onAdd={onRecurringActivityAdd}
      />

      <UpdateRecurringActivityDialog
        open={openDialog.UPDATE_RECURRING_ACTIVITY}
        setOpen={toggleDialogOpen}
        lowestTasks={lowestTasks}
        employees={employees}
        projectData={projectData}
        selectedActivity={recurringActivities.find(
          (a) => a.id === selectedRecurringActivityRow
        )}
        onUpdate={onRecurringActivityUpdate}
      />
      <ProjectTaskAddActivityDialog
        selectedChild={selectedChild}
        taskCodeBool={taskCodeBool}
        setTaskCodeBool={setTaskCodeBool}
        open={openDialog.PROJECT_TASK_ADD_ACTIVITY}
        setOpen={toggleDialogOpen}
        lowestTasks={lowestTasks}
        employees={employees}
        onAdd={onProjectTaskActivityAdd}
      />
      <AddEmployeeDialog
        selectedChild={selectedChild}
        taskCodeBool={taskCodeBool}
        setTaskCodeBool={setTaskCodeBool}
        open={openDialog.ADD_EMPLOYEE}
        setOpen={toggleDialogOpen}
        onAdd={handleEmployeeAdd}
        employees={employees}
        token={user.token}
        lowestTasks={lowestTasks}
        project_id={projectData.id}
        projectType={localStorage.getItem("projectType")}
      />
      <ProjectTaskAddEmployeeDialog
        open={openDialog.PROJECT_TASK_ADD_EMPLOYEE}
        setOpen={toggleDialogOpen}
        onAdd={handleProjectTaskEmployeeAdd}
        employees={employees}
        token={user.token}
        lowestTasks={lowestTasks}
        project_id={projectData.id}
        projectType={localStorage.getItem("projectType")}
      />



    </Box>
  );
}

function Loading() {
  return (
    <div className="page d-flex">
      <div className="m-auto text-center">
        <CircularProgress />
      </div>
    </div>
  );
}

function createTree(data, parentId) {
  let children = data.filter((d) => d.parent_task_id === parentId);
  if (!children.length) return null;
  else {
    children.forEach((c) => {
      c["children"] = createTree(data, c.id);
    });
  }
  return children;
}

// function getUpdatableProjectData(data) {
//   return {
//     project_name: data.project_name,
//     start_date: data.start_date,
//     end_date: data.end_date,
//     budget: data.budget,
//     project_description: data.project_description,
//     project_type: data.projectType,
//     status: data.status,
//   };
// }

function getFromattedActualAndBudgetData(data = []) {
  data = getLowest(data);
  let actuals = [];
  let budgets = [];
  let xAxis = [];
  data.forEach((t) => {
    actuals.push(t.actual);
    budgets.push(t.budget);
    xAxis.push(t.task_code);
  });

  return {
    series: [
      { name: "Actuals", data: actuals },
      { name: "Budget", data: budgets },
    ],
    xAxis,
  };
}

function getFromattedActualAndCostData(data = []) {
  data = getLowest(data);
  let actuals = [];
  let costs = [];
  let xAxis = [];
  data.forEach((t) => {
    actuals.push(t.actual);
    costs.push(t.cost);
    xAxis.push(t.task_code);
  });

  return {
    series: [
      { name: "Actuals", data: actuals },
      { name: "Cost", data: costs },
    ],
    xAxis,
  };
}

function getPorojectCompletionPercent(tasks = []) {
  let tops = tasks.filter((t) => !t.parent_task_id);
  let sum = tops
    .map((t) => parseFloat(t.percent_complete))
    .reduce((a, b) => a + b, 0);
  let per = parseFloat(sum / tops.length).toFixed(2);
  return per;
}

function getLowest(data = []) {
  let parents = [];
  data.forEach((d) => {
    if (d.parent_task_id && !parents.includes(d.parent_task_id)) {
      parents.push(d.parent_task_id);
    }
  });
  return data.filter((d) => !parents.includes(d.id));
}

function addAdditionalColumn(obj, setProjectEmployee) {
  if (obj === undefined) {
    projectEmployeesTable.push({
      headerName: "Bill Rate",
      field: "bill_rate",
      resizable: true,
      valueFormatter: formatCurrency,
    });
  }
  setProjectEmployee(projectEmployeesTable);
}
function addAdditionalColumnProjectTaskTable(obj) {
  if (obj === undefined) {
    projectTaskTable.push(
      {
        headerName: "Cost",
        field: "cost",
        minWidth: 80,
        wrapText: true,
        autoHeight: true,
        cellClass: "pmt-ag-cell-font capitalizeNone justify-right",
        headerClass: "justify-right",
        valueFormatter: (v) => "$" + new Intl.NumberFormat("en-US").format(v),
      },
      {
        headerName: "Actual",
        field: "actual",
        minWidth: 80,
        wrapText: true,
        autoHeight: true,
        cellClass: "pmt-ag-cell-font capitalizeNone",
        valueFormatter: (v) => "$" + new Intl.NumberFormat("en-US").format(v),
      },
      {
        headerName: "Budget",
        field: "budget",
        minWidth: 80,
        wrapText: true,
        autoHeight: true,
        cellClass: "pmt-ag-cell-font capitalizeNone justify-right",
        headerClass: "justify-right",
        valueFormatter: (v) => "$" + new Intl.NumberFormat("en-US").format(v),
      }
    );
  }
}
